import React from 'react';
import { NavItemType, type IconsProps, type INavViewItem } from '@makemydeal/dr-sales-checkin-types';

import Buyer from '../Customer/Buyer';
import Cobuyer from '../Customer/Cobuyer';
import AddCoBuyer from '../Customer/AddCoBuyer';
import CustomerInbox from '../Customer/CustomerInbox';
import SendLinkDropdown from '../SendLinkDropdown/SendLinkDropdown';
import DealComments from '../DealComments/DealComments';
import SendToDeskButton from '../SendToDeskButton/SendToDeskButton';

/**
 * Dumb dispatcher: renders the presentational component for a resolved nav view
 * item based on its `type`. Keeps NavBar a pure loop — adding a new top-nav item
 * kind means one case here, and the discriminated union makes the compiler flag a
 * missing one.
 */
const NavBarItem: React.FC<{ item: INavViewItem }> = ({ item }) => {
    switch (item.type) {
        case NavItemType.CustomerName:
            return <Buyer name={item.label} onBuyerClick={item.clickAction.execute} />;
        case NavItemType.Cobuyer:
            return (
                <Cobuyer
                    icon={item.icon as React.ComponentType<IconsProps>}
                    name={item.label}
                    onCobuyerClick={item.clickAction.execute}
                    onRemove={item.removeAction.execute}
                />
            );
        case NavItemType.AddCobuyer:
            return <AddCoBuyer icon={item.icon} onAddCoBuyer={item.addAction.execute} />;
        case NavItemType.Inbox:
            return <CustomerInbox label={item.label} onClick={item.clickAction.execute} isVisible />;
        case NavItemType.SendToDesk:
            return <SendToDeskButton item={item} />;
        case NavItemType.ShareDropdown:
            return <SendLinkDropdown items={item.items} />;
        case NavItemType.DealComments:
            return <DealComments />;
        default:
            return null;
    }
};

export default NavBarItem;
